// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submit-btn-contract {
  background-color: #FDE802 !important;
  border-color: none !important;
  border-radius: 5px !important;

}

/* Label styling */
.contract-label {
  color: #23282C !important;
  font-family: 'Noto Sans', sans-serif !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 24px !important;
}

.form-control::placeholder {
  color: #292F36 !important;
  font-family: 'Noto Sans', sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 24px !important;
}

.form-control {
  color: #292F36 !important;
  font-family: 'Noto Sans', sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 24px !important;
}

.contrcat-input {
  color: #292F36 !important;
  font-family: 'Noto Sans', sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 24px !important;
}


.submit-btn-contract span {
  font-family: Noto Sans;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000 !important;
}

.form-control {
  font-family: "Open Sans";
}

.breadcrumb-item+.breadcrumb-item::before {
  float: none !important;
  padding-right: .5rem;
  color: #6c757d;
  content: "/";
}

.create-contract-title {
  font-family: Noto Sans;
  font-weight: 500;
  font-size: 17px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
}

.custom-datepicker {
  color: #292F36 !important;
  font-family: 'Noto Sans', sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 24px !important;
  border: 1px solid #d2d6da;
  padding: 6px 12px;
  border-radius: 4px;
  width: 100%;
}


.custom-datepicker::placeholder {
  color: #292F36 !important;
  font-family: 'Noto Sans', sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 24px !important;
}

.react-datepicker-wrapper {
  width: 100% !important;
  display: inline-block;
  padding: 0;
  border: 0;
}

.Contrcat-conatiner {
  margin-top: 3rem;
}

.send-title {
  font-family: Noto Sans;
  font-weight: 600;
  font-size: 25px;
  line-height: 25px;
  letter-spacing: 0%;
  text-align: center;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contract-text p {
  font-family: Noto Sans;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #000000;
}


.sendcontrcat-container {
  width: 900px;
  margin: auto;
}

.sendcontrcat-innercontainer {
  background: #ffff;
  border: 1px solid #999C9F;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

@media (max-width:576px) {
  .sendcontrcat-innercontainer {
    background: #ffff;
    border: 1px solid #999C9F;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

  }

  .sendcontrcat-container {
    width: 100%;
    margin: auto;
  }
}

.send-contract-btn {
  width: 141px;
  background: #f40;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  line-height: 24px;
  border-style: none;
}

.edit-btn {
  font-family: Noto Sans;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  background: transparent;
  border-style: none;
  color: #000000;
}

.homepage-title span {
  font-family: Noto Sans;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: #FDE802
}

.generated-message img {
  height: 24px;
  width: 24px;
}

.sccuess-conatiner img {
  height: 200px;
  width: 200px;
}
.scuess-page{
height: 100vh;
background: #000000;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Contract/contract.css"],"names":[],"mappings":"AAGA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,6BAA6B;;AAE/B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;;AAGA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;;AAGA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;;AAGA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;;EAE3C;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;AACA;AACA,aAAa;AACb,mBAAmB;AACnB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');\r\n\r\n\r\n.submit-btn-contract {\r\n  background-color: #FDE802 !important;\r\n  border-color: none !important;\r\n  border-radius: 5px !important;\r\n\r\n}\r\n\r\n/* Label styling */\r\n.contract-label {\r\n  color: #23282C !important;\r\n  font-family: 'Noto Sans', sans-serif !important;\r\n  font-weight: 500 !important;\r\n  font-size: 16px !important;\r\n  line-height: 24px !important;\r\n}\r\n\r\n.form-control::placeholder {\r\n  color: #292F36 !important;\r\n  font-family: 'Noto Sans', sans-serif !important;\r\n  font-weight: 500 !important;\r\n  font-size: 14px !important;\r\n  line-height: 24px !important;\r\n}\r\n\r\n.form-control {\r\n  color: #292F36 !important;\r\n  font-family: 'Noto Sans', sans-serif !important;\r\n  font-weight: 500 !important;\r\n  font-size: 14px !important;\r\n  line-height: 24px !important;\r\n}\r\n\r\n.contrcat-input {\r\n  color: #292F36 !important;\r\n  font-family: 'Noto Sans', sans-serif !important;\r\n  font-weight: 500 !important;\r\n  font-size: 14px !important;\r\n  line-height: 24px !important;\r\n}\r\n\r\n\r\n.submit-btn-contract span {\r\n  font-family: Noto Sans;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  color: #000000 !important;\r\n}\r\n\r\n.form-control {\r\n  font-family: \"Open Sans\";\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item::before {\r\n  float: none !important;\r\n  padding-right: .5rem;\r\n  color: #6c757d;\r\n  content: \"/\";\r\n}\r\n\r\n.create-contract-title {\r\n  font-family: Noto Sans;\r\n  font-weight: 500;\r\n  font-size: 17px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  color: #000000;\r\n}\r\n\r\n.custom-datepicker {\r\n  color: #292F36 !important;\r\n  font-family: 'Noto Sans', sans-serif !important;\r\n  font-weight: 500 !important;\r\n  font-size: 14px !important;\r\n  line-height: 24px !important;\r\n  border: 1px solid #d2d6da;\r\n  padding: 6px 12px;\r\n  border-radius: 4px;\r\n  width: 100%;\r\n}\r\n\r\n\r\n.custom-datepicker::placeholder {\r\n  color: #292F36 !important;\r\n  font-family: 'Noto Sans', sans-serif !important;\r\n  font-weight: 500 !important;\r\n  font-size: 14px !important;\r\n  line-height: 24px !important;\r\n}\r\n\r\n.react-datepicker-wrapper {\r\n  width: 100% !important;\r\n  display: inline-block;\r\n  padding: 0;\r\n  border: 0;\r\n}\r\n\r\n.Contrcat-conatiner {\r\n  margin-top: 3rem;\r\n}\r\n\r\n.send-title {\r\n  font-family: Noto Sans;\r\n  font-weight: 600;\r\n  font-size: 25px;\r\n  line-height: 25px;\r\n  letter-spacing: 0%;\r\n  text-align: center;\r\n  color: #000000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.contract-text p {\r\n  font-family: Noto Sans;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  vertical-align: middle;\r\n  color: #000000;\r\n}\r\n\r\n\r\n.sendcontrcat-container {\r\n  width: 900px;\r\n  margin: auto;\r\n}\r\n\r\n.sendcontrcat-innercontainer {\r\n  background: #ffff;\r\n  border: 1px solid #999C9F;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n@media (max-width:576px) {\r\n  .sendcontrcat-innercontainer {\r\n    background: #ffff;\r\n    border: 1px solid #999C9F;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n\r\n  }\r\n\r\n  .sendcontrcat-container {\r\n    width: 100%;\r\n    margin: auto;\r\n  }\r\n}\r\n\r\n.send-contract-btn {\r\n  width: 141px;\r\n  background: #f40;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  border-style: none;\r\n}\r\n\r\n.edit-btn {\r\n  font-family: Noto Sans;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  letter-spacing: 0%;\r\n  background: transparent;\r\n  border-style: none;\r\n  color: #000000;\r\n}\r\n\r\n.homepage-title span {\r\n  font-family: Noto Sans;\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n  line-height: 16px;\r\n  letter-spacing: 0%;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  color: #FDE802\r\n}\r\n\r\n.generated-message img {\r\n  height: 24px;\r\n  width: 24px;\r\n}\r\n\r\n.sccuess-conatiner img {\r\n  height: 200px;\r\n  width: 200px;\r\n}\r\n.scuess-page{\r\nheight: 100vh;\r\nbackground: #000000;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
